import image1 from '../../images/charleskimdentistry-68.jpg';
import image2 from '../../images/charleskimdentistry-edited-21.jpg';
import image3 from '../../images/charleskimdentistry-101.jpg';
import image4 from '../../images/charleskimdentistry-90.jpg';
import image5 from '../../images/charleskimdentistry-79.jpg';
import image6 from '../../images/charleskimdentistry-41.jpg';
import image7 from '../../images/charleskimdentistry-34.jpg';
import image8 from '../../images/charleskimdentistry-11.jpg';

const files = [
    {
      title: 'IMG_4985.HEIC',
      size: '3.9 MB',
      source: image3,
    },
    {
        title: 'IMG_4985.HEIC',
        size: '3.9 MB',
        source: image4,
      },
      {
        title: 'IMG_4985.HEIC',
        size: '3.9 MB',
        source: image2,
      },
      {
        title: 'IMG_4985.HEIC',
        size: '3.9 MB',
        source: image5,
      },
      {
        title: 'IMG_4985.HEIC',
        size: '3.9 MB',
        source: image6,
      },
      {
        title: 'IMG_4985.HEIC',
        size: '3.9 MB',
        source: image7,
      },
      {
        title: 'IMG_4985.HEIC',
        size: '3.9 MB',
        source: image8,
      },
      {
        title: 'IMG_4985.HEIC',
        size: '3.9 MB',
        source: image1,
      },
  ]
  
  export default function OurOffice() {
    return (
        <div className="bg-white">
      {/* Header */}
      <div className="relative pb-32 bg-gray-400">
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-cover"
            src={image1}
            alt=""
          />
          <div className="absolute inset-0 bg-gray-400 mix-blend-multiply" aria-hidden="true" />
        </div>
        <div className="relative max-w-7xl mx-auto py-20 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold tracking-normal text-white md:text-5xl md:tracking-normal lg:tracking-normal">
            Our Safe Space
          </h2>
        </div>
      </div>

      {/* Overlapping cards */}
      <section
        className="-mt-32 max-w-7xl mx-auto relative z-10 pb-32 px-4 sm:px-6 lg:px-8"
        aria-labelledby="contact-heading"
      >
        <ul role="list" className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
            {files.map((file) => (
            <li key={file.source} className="relative">
                <div className="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden">
                <img src={file.source} alt="" className="object-cover pointer-events-none group-hover:opacity-75" />
                <button type="button" className="absolute inset-0 focus:outline-none">
                    <span className="sr-only">View details for {file.title}</span>
                </button>
                </div>
            </li>
            ))}
        </ul>
      </section>
    </div>
    )
  }
  